'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var makeRenderlessComponent = function (hook) {
  return function (props) {
    hook(props);
    return null;
  };
};

exports.makeRenderlessComponent = makeRenderlessComponent;
